module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_01.8943b2a4.png";